export const entity_language = { 
  entity: { 
    "user": "Utenti", 
    "user_group": "Gruppi", 
    "user_entity_saved_filters": "Filtri salvati", 
    "user_entity_preferences": "Preferenze entità", 
    "log": "Log di sistema", 
    "quotation": "Preventivo", 
    "user_answer": "Risposte utente", 
    "assessment": "Questionari", 
    "assessment_step": "Step questionario", 
    "question_first_level": "Domande primo livello", 
    "question_second_level": "Domande secondo livello", 
    "gyv_apartment_assessment_step": "Step questionario appartamento", 
    "gyv_bathroom_assessment_step": "Step questionario bagno", 
    "gyv_order_question_first_level": "Domande ordinate primo livello", 
    "gyv_order_question_second_level": "Domande ordinate secondo livello", 
    "news": "News", 
    "news_category": "Categorie news", 
    "config": "Configurazione App", 
    "notify_device": "Dispositivi notificabili",
    "media": "Media",
    "referral_code": "Codici Referral",
    "gyv_referral_code_stats": "Codici Referral"
  },
  labels: { 
    "user": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato",
      "level": "Livello",
      "level.options.1": "User",
      "level.options.0": "Admin",
      "level.options.999": "Guest",
      "name": "Nome", 
      "surname": "Cognome", 
      "username": "Nome utente", 
      "email": "Email", 
      "password": "Password", 
      "phone": "Telefono", 
      "address": "Indirizzo", 
      "cf": "Codice fiscale", 
      "privacy": "Privacy", 
      "marketing": "Marketing", 
      "idUserGroup": "Gruppo utente", 
      "referralCode": "Referral Code"
    }, 
    "user_group": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "name": "Nome" 
    }, 
    "user_entity_saved_filters": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "entity": "Entità", 
      "name": "Nome", 
      "notes": "Note", 
      "content": "Contenuto" 
    }, 
    "user_entity_preferences": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "entity": "Entità", 
      "label": "Etichetta", 
      "isDefault": "Predefinito", 
      "content": "Contenuto" 
    }, 
    "log": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "idUser": "Utente", 
      "entity": "Entità", 
      "idItem": "ID elemento", 
      "operation": "Operazione", 
      "operation.options.0_DELETE": "Eliminazione", 
      "operation.options.1_EDIT": "Modifica", 
      "operation.options.2_ADD": "Aggiunta", 
      "operation.options.3_LOGIN": "Login", 
      "operation.options.4_LOGOUT": "Logout", 
      "notes": "Note" 
    }, 
    "quotation": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "idUser": "Utente", 
      "idAssessment": "Questionario", 
      "idAssessment.options.1": "Appartamento", 
      "idAssessment.options.2": "Bagno", 
      "baseTotal": "Totale incluso", 
      "extraTotal": "Totale escluso", 
      "user_answers": "Risposte utente", 
      "file": "Allegato", 
      "notes": "Note",
      "title": "Titolo",
      "adminMailStatus": "Stato invio email amministratori",
      "adminMailStatus.options.10_IN_PENDING": "In attesa di invio",
      "adminMailStatus.options.20_NOT_SENT": "Non inviata",
      "adminMailStatus.options.30_SENT": "Inviata",
      "adminMailStatus.options.40_ERROR": "Errore",
      "userMailStatus": "Stato invio email cliente",
      "userMailStatus.options.10_IN_PENDING": "In attesa di invio",
      "userMailStatus.options.20_NOT_SENT": "Non inviata",
      "userMailStatus.options.30_SENT": "Inviata",
      "userMailStatus.options.40_ERROR": "Errore nell'invio"
    }, 
    "user_answer": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "idQuotation": "ID preventivo", 
      "idQuestionFirstLevel": "ID domanda primo livello", 
      "idQuestion": "ID domanda",

      "questionTitle": "Titolo domanda", 
      "questionDescription": "Descrizione domanda", 
      "questionType": "Tipologia domanda", 
      "questionType.options.number": "Numero", 
      "questionType.options.text": "Testuale", 
      "questionType.options.boolean": "Vero / Falso", 
      "questionType.options.select": "Selezione", 
      "questionType.options.select_option": "Valore selezionato", 
      "answer": "Risposta",
      "unitPrice": "Prezzo unitario",
      "totalPrice": "Prezzo totale"
    }, 
    "assessment": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "title": "Titolo", 
      "title.options.1_APARTMENT": "Appartamento", 
      "title.options.2_BATHROOM": "Bagno",
      "idAssessmentSteps": "Step",
    }, 
    "gyv_referral_code_stats": {
      "id": "id",
      "date": "Data",
      "lastUpdate": "Ultimo aggiornamento",
      "deleted": "Eliminato",
      "author": "Utente",
      "expireDateTime": "Scadenza",
      "code": "Codice",
      "partnerName": "Nome partner",
      "notes": "Note",
      "totalUses": "Utilizzi",
      "lastUse": "Ultimo utilizzo",
    },
    "referral_code": {
      "id": "id",
      "date": "Data",
      "lastUpdate": "Ultimo aggiornamento",
      "deleted": "Eliminato",
      "author": "Utente",
      "expireDateTime": "Scadenza",
      "code": "Codice",
      "partnerName": "Nome partner",
      "notes": "Note",
    }, 
    "assessment_step": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "internalTitle": "Titolo in preventivo", 
      "idAssessment": "Questionario", 
      "idAssessment.options.1": "Appartamento", 
      "idAssessment.options.2": "Bagno", 
      "position": "Posizione", 
      "title": "Titolo app", 
      "description": "Descrizione", 
      "questions": "Domande", 
      "hasPopup": "Popup attivo", 
      "popupTitle": "Titolo popup", 
      "popupDescription": "Descrizione popup", 
      "popupVideo": "Url Video popup" 
    }, 
    "question": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "idAssessmentStep": "ID Step questionario", 
      "position": "Posizione", 
      "label": "Etichetta", 
      "placeholder": "Segnaposto", 
      "initialState": "Stato iniziale", 
      "initialState.options.null": "Nessuno stato iniziale", 
      "initialState.options.false": "Nessuno stato iniziale", 
      "initialState.options.true": "Vero", 
      "initialState.options.1": "1", 
      "initialState.options.0": "0", 
      "numberMin": "Numero minimo", 
      "numberMax": "Numero massimo",
      "description": "Descrizione", 
      "inputType": "Tipologia campo", 
      "inputType.options.number": "Numero", 
      "inputType.options.text": "Testo", 
      "inputType.options.boolean": "Booleano", 
      "inputType.options.video": "Video", 
      "inputType.options.select": "Selezione", 
      "questionSecondLevels": "Domande di secondo livello", 
      "isExtra": "Spostalo in extra", 
      "unitPrice": "Prezzo unitario",
      "totalPrice": "Prezzo totale",
      "definition": "Definizione",
      "helper": "Descrizione di aiuto",
      "ignoreOnSummary": "ignora nel preventivo",
      "internalIdentifier": "Identificativo interno",
      "internalIdentifier.options.email": "Email (email)",
      "internalIdentifier.options.address": "Indirizzo (address)",
      "internalIdentifier.options.phone": "Telefono (phone)",
      "internalIdentifier.options.cf": "Codice Fiscale (cf)",
      "internalIdentifier.options.nameSurname": "Nome completo (nameSurname)",
      "internalIdentifier.options.projectName": "Nome progetto (projectName)",
      "internalIdentifier.options.assessmentTypeName": "Tipologia preventivo (Assessmenttypename)",
      "internalIdentifier.options.NULL": "Nessuno (null)"
    }, 
    "question_first_level": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "idAssessmentStep": "ID Step questionario", 
      "position": "Posizione", 
      "label": "Etichetta", 
      "placeholder": "Segnaposto", 
      "initialState": "Stato iniziale", 
      "initialState.options.null": "Nessuno stato iniziale", 
      "initialState.options.false": "Nessuno stato iniziale", 
      "initialState.options.true": "Vero", 
      "initialState.options.1": "1", 
      "initialState.options.0": "0", 
      "numberMin": "Numero minimo", 
      "numberMax": "Numero massimo",
      "description": "Descrizione", 
      "inputType": "Tipologia campo", 
      "inputType.options.number": "Numero", 
      "inputType.options.text": "Testo", 
      "inputType.options.boolean": "Booleano", 
      "inputType.options.video": "Video", 
      "inputType.options.select": "Selezione", 
      "questionSecondLevels": "Domande di secondo livello", 
      "isExtra": "Spostalo in extra", 
      "unitPrice": "Prezzo unitario" 
    }, 
    "question_second_level": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "idQuestionFirstLevel": "ID domanda primo livello", 
      "position": "Posizione", 
      "label": "Etichetta", 
      "initialState": "Stato iniziale", 
      "initialState.options.null": "Nessuno stato iniziale", 
"initialState.options.false": "Nessuno stato iniziale", 
      "initialState.options.true": "Vero", 
      "initialState.options.1": "1", 
      "initialState.options.0": "0", 
      "description": "Descrizione", 
      "inputType": "Tipologia campo", 
      "inputType.options.select_option": "Opzione",       
      "photo": "Foto", 
      "unitPrice": "Prezzo unitario" 
    }, 
    "gyv_apartment_assessment_step": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "internalTitle": "Titolo interno", 
      "idAssessment": "Questionario", 
      "idAssessment.options.1": "Appartamento", 
      "position": "Posizione", 
      "title": "Titolo", 
      "description": "Descrizione", 
      "questions": "Domande",
      "hasPopup": "Popup attivo", 
      "popupTitle": "Titolo popup", 
      "popupDescription": "Descrizione popup", 
      "popupVideo": "Url Video popup" 
    }, 
    "gyv_bathroom_assessment_step": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "internalTitle": "Titolo interno", 
      "idAssessment": "Questionario", 
      "idAssessment.options.2": "Bagni", 
      "position": "Posizione", 
      "title": "Titolo", 
      "description": "Descrizione", 
      "questions": "Domande" ,
      "hasPopup": "Popup attivo", 
      "popupTitle": "Titolo popup", 
      "popupDescription": "Descrizione popup", 
      "popupVideo": "Url Video popup" 
    }, 
    "gyv_order_question_first_level": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "idAssessmentStep": "ID Step questionario", 
      "position": "Posizione", 
      "label": "Etichetta", 
      "placeholder": "Segnaposto", 
      "initialState": "Stato iniziale", 
      "initialState.options.null": "Nessuno stato iniziale", 
"initialState.options.false": "Nessuno stato iniziale", 
      "initialState.options.true": "Vero", 
      "initialState.options.1": "1", 
      "initialState.options.0": "0", 
      "numberMin": "Numero minimo", 
      "numberMax": "Numero massimo",
      "description": "Descrizione", 
      "inputType": "Tipologia campo", 
      "inputType.options.number": "Numero", 
      "inputType.options.text": "Testo", 
      "inputType.options.boolean": "Booleano", 
      "inputType.options.select": "Selezione", 
      "questionSecondLevels": "Domande di secondo livello", 
      "isExtra": "Spostalo in extra", 
      "unitPrice": "Prezzo unitario" 
    }, 
    "gyv_order_question_second_level": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "author": "Utente", 
      "idFirstLevelQuestion": "ID domanda primo livello", 
      "position": "Posizione", 
      "label": "Etichetta", 
      "initialState": "Stato iniziale", 
      "initialState.options.null": "Nessuno stato iniziale", 
      "initialState.options.false": "Nessuno stato iniziale", 
      "initialState.options.true": "Vero", 
      "initialState.options.1": "1", 
      "initialState.options.0": "0", 
      "description": "Descrizione", 
      "inputType": "Tipologia campo", 
      "inputType.options.select_option": "Opzione",       
      "photo": "Foto", 
      "unitPrice": "Prezzo unitario" 
    }, 
    "news": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "title": "Titolo", 
      "idNewsCategory": "Categoria news", 
      "photo": "Foto", 
      "body": "Testo" 
    }, 
    "news_category": { 
      "id": "id", 
      "date": "Data", 
      "lastUpdate": "Ultimo aggiornamento", 
      "deleted": "Eliminato", 
      "name": "Nome" 
    }, 
    "config": {
      "id": "id",
      "date": "Data",
      "lastUpdate": "Ultimo aggiornamento",
      "deleted": "Eliminato",
      "config_name": "Chiave",
      "config_value": "Valore"
    }, 
    "notify_device": {
      "id": "id",
      "date": "Data",
      "lastUpdate": "Ultimo aggiornamento",
      "deleted": "Eliminato",
      "author": "Utente",
      "expoToken": "Token Expo"
    },
    "media": {
      "id": "id",
      "date": "Data",
      "lastUpdate": "Ultimo aggiornamento",
      "deleted": "Eliminato",
      "author": "Utente",
      "internalName": "Nome interno",
      "file": "File"
    }
  }
}; 
